"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMarkActive = void 0;
const slate_1 = require("slate");
const isMarkActive = (editor, format) => {
    const marks = slate_1.Editor.marks(editor);
    return marks ? !!marks[format] === true : false;
};
exports.isMarkActive = isMarkActive;
//# sourceMappingURL=is-mark-active.js.map